/**
 * AUTO-GENERATED by build_layers_A.sh — do not edit by hand.
 * L0 is the FARTHEST slice (opaque backstop, inpainted); the last is the subject.
 * blur/haze rise with distance — that is atmospheric perspective, worth more than
 * another depth slice (research_motion/02 §6).
 */
export type L = { src: string; z: number; blur?: number; haze?: number };
export const A: Record<string, L[]> = {
  A1_courtyard: [
    { src: "sanatan45/A/layers/A1_courtyard_L0.png", z: 1500.0, blur: 3.2, haze: 0.3 },
    { src: "sanatan45/A/layers/A1_courtyard_L1.png", z: 1017.2, blur: 2.0, haze: 0.2 },
    { src: "sanatan45/A/layers/A1_courtyard_L2.png", z: 588.4, blur: 1.1, haze: 0.11 },
    { src: "sanatan45/A/layers/A1_courtyard_L3.png", z: 230.8, blur: 0.4, haze: 0.04 },
    { src: "sanatan45/A/layers/A1_courtyard_L4.png", z: 0.0, blur: 0.0, haze: 0.0 },
  ],
  A2_register: [
    { src: "sanatan45/A/layers/A2_register_L0.png", z: 1500.0, blur: 3.2, haze: 0.3 },
    { src: "sanatan45/A/layers/A2_register_L1.png", z: 1017.2, blur: 2.0, haze: 0.2 },
    { src: "sanatan45/A/layers/A2_register_L2.png", z: 588.4, blur: 1.1, haze: 0.11 },
    { src: "sanatan45/A/layers/A2_register_L3.png", z: 230.8, blur: 0.4, haze: 0.04 },
    { src: "sanatan45/A/layers/A2_register_L4.png", z: 0.0, blur: 0.0, haze: 0.0 },
  ],
  A3_phonecall: [
    { src: "sanatan45/A/layers/A3_phonecall_L0.png", z: 1500.0, blur: 3.2, haze: 0.3 },
    { src: "sanatan45/A/layers/A3_phonecall_L1.png", z: 1017.2, blur: 2.0, haze: 0.2 },
    { src: "sanatan45/A/layers/A3_phonecall_L2.png", z: 588.4, blur: 1.1, haze: 0.11 },
    { src: "sanatan45/A/layers/A3_phonecall_L3.png", z: 230.8, blur: 0.4, haze: 0.04 },
    { src: "sanatan45/A/layers/A3_phonecall_L4.png", z: 0.0, blur: 0.0, haze: 0.0 },
  ],
  A4_lamp_void: [
    { src: "sanatan45/A/layers/A4_lamp_void_L0.png", z: 1500.0, blur: 3.2, haze: 0.3 },
    { src: "sanatan45/A/layers/A4_lamp_void_L1.png", z: 1017.2, blur: 2.0, haze: 0.2 },
    { src: "sanatan45/A/layers/A4_lamp_void_L2.png", z: 588.4, blur: 1.1, haze: 0.11 },
    { src: "sanatan45/A/layers/A4_lamp_void_L3.png", z: 230.8, blur: 0.4, haze: 0.04 },
    { src: "sanatan45/A/layers/A4_lamp_void_L4.png", z: 0.0, blur: 0.0, haze: 0.0 },
  ],
  A5_three_pillars: [
    { src: "sanatan45/A/layers/A5_three_pillars_L0.png", z: 1500.0, blur: 3.2, haze: 0.3 },
    { src: "sanatan45/A/layers/A5_three_pillars_L1.png", z: 1017.2, blur: 2.0, haze: 0.2 },
    { src: "sanatan45/A/layers/A5_three_pillars_L2.png", z: 588.4, blur: 1.1, haze: 0.11 },
    { src: "sanatan45/A/layers/A5_three_pillars_L3.png", z: 230.8, blur: 0.4, haze: 0.04 },
    { src: "sanatan45/A/layers/A5_three_pillars_L4.png", z: 0.0, blur: 0.0, haze: 0.0 },
  ],
  A6_corridor: [
    { src: "sanatan45/A/layers/A6_corridor_L0.png", z: 1500.0, blur: 3.2, haze: 0.3 },
    { src: "sanatan45/A/layers/A6_corridor_L1.png", z: 1017.2, blur: 2.0, haze: 0.2 },
    { src: "sanatan45/A/layers/A6_corridor_L2.png", z: 588.4, blur: 1.1, haze: 0.11 },
    { src: "sanatan45/A/layers/A6_corridor_L3.png", z: 230.8, blur: 0.4, haze: 0.04 },
    { src: "sanatan45/A/layers/A6_corridor_L4.png", z: 0.0, blur: 0.0, haze: 0.0 },
  ],
  A7_banyan_roots: [
    { src: "sanatan45/A/layers/A7_banyan_roots_L0.png", z: 1500.0, blur: 3.2, haze: 0.3 },
    { src: "sanatan45/A/layers/A7_banyan_roots_L1.png", z: 1017.2, blur: 2.0, haze: 0.2 },
    { src: "sanatan45/A/layers/A7_banyan_roots_L2.png", z: 588.4, blur: 1.1, haze: 0.11 },
    { src: "sanatan45/A/layers/A7_banyan_roots_L3.png", z: 230.8, blur: 0.4, haze: 0.04 },
    { src: "sanatan45/A/layers/A7_banyan_roots_L4.png", z: 0.0, blur: 0.0, haze: 0.0 },
  ],
  A8_ancestor_column: [
    { src: "sanatan45/A/layers/A8_ancestor_column_L0.png", z: 1500.0, blur: 3.2, haze: 0.3 },
    { src: "sanatan45/A/layers/A8_ancestor_column_L1.png", z: 1017.2, blur: 2.0, haze: 0.2 },
    { src: "sanatan45/A/layers/A8_ancestor_column_L2.png", z: 588.4, blur: 1.1, haze: 0.11 },
    { src: "sanatan45/A/layers/A8_ancestor_column_L3.png", z: 230.8, blur: 0.4, haze: 0.04 },
    { src: "sanatan45/A/layers/A8_ancestor_column_L4.png", z: 0.0, blur: 0.0, haze: 0.0 },
  ],
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
